import { APP_PROMO_CLICK, APP_PROMO_CODE, APP_VISITOR_ID } from '@common/constants';
import { reactLocalStorage } from 'reactjs-localstorage';

export const PROMO_LINK_DAYS = 30;

const LANDINGS: Record<string, string> = {
  deposit: '/deposit',
  home: '/',
  line: '/prematches',
  live: '/live',
  bonuses: '/bonus-previews',
};

const now = () => Math.floor(Date.now() / 1000);

export function landingPath(landing: string | undefined): string {
  return (landing && LANDINGS[landing]) || '/';
}

export function isPromoCode(value: string | null): value is string {
  return Boolean(value && /^[A-Za-z0-9_-]{2,45}$/.test(value));
}

export function isLinkSlug(value: string | null): value is string {
  return Boolean(value && /^[a-z0-9][a-z0-9-]{1,39}$/.test(value));
}

export function storePromoCode(code: string): void {
  reactLocalStorage.setObject(APP_PROMO_CODE, { code, exp: now() + PROMO_LINK_DAYS * 86400 });
}

export function storePromoClick(clickId: string, code: string): void {
  reactLocalStorage.setObject(APP_PROMO_CLICK, { clickId, code, exp: now() + PROMO_LINK_DAYS * 86400 });
}

export function readStoredPromoCode(): string {
  const stored = reactLocalStorage.getObject(APP_PROMO_CODE, {}) as { code?: string; exp?: number };
  return stored && stored.code && stored.exp && stored.exp > now() ? String(stored.code) : '';
}

export function readStoredPromoClick(): string | undefined {
  const stored = reactLocalStorage.getObject(APP_PROMO_CLICK, {}) as { clickId?: string; exp?: number };
  return stored && stored.clickId && /^[0-9a-f]{32}$/.test(stored.clickId) && stored.exp && stored.exp > now() ? stored.clickId : undefined;
}

export function visitorId(): string {
  const existing = reactLocalStorage.get<string | undefined>(APP_VISITOR_ID);
  if (existing && /^[A-Za-z0-9-]{16,64}$/.test(existing)) return existing;
  const created = typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}-${Math.random().toString(36).slice(2, 12)}`;
  reactLocalStorage.set(APP_VISITOR_ID, created);
  return created;
}
